import { render, staticRenderFns } from "./shjh_ct.vue?vue&type=template&id=52f7b43c&scoped=true"
import script from "./shjh_ct.vue?vue&type=script&lang=js"
export * from "./shjh_ct.vue?vue&type=script&lang=js"
import style0 from "./shjh_ct.vue?vue&type=style&index=0&id=52f7b43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f7b43c",
  null
  
)

export default component.exports